export const CHART4_REQUEST = "CHART4_REQUEST";
export const CHART4_SUCCESS = "CHART4_SUCCESS";
export const CHART4_FAILURE = "CHART4_FAILURE";
